import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Kode } from '../../Utils'
import Texteditor from "./Texteditor"
import axiosJWT from '../../JwtToken'

export const Add = ({ getData, closeAdd, getPesan, setMsg }) => {

  const [kode] = useState(Kode)
  const [potensialCode, setPotensialCode] = useState('')
  const [potensialName, setPotensialName] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [files, setFiles] = useState([null, null, null, null, null])
  const [previews, setPreviews] = useState([null, null, null, null, null])
  const [data, setData] = useState([])
  const [editorLoaded, setEditorLoaded] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    getPotencial()
    setEditorLoaded(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getPotencial = async (key) => {
    try {
      const response = await axiosJWT.post("/api/kegiatan-usaha/publish", {
        key: key
      })
      setData(response.data)
    } catch (err) {
      getPesan()
      setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
      setTimeout(() => {
        getPesan()
        setMsg("")
      }, 2000)
    }
  }

  const getPotencialName = async (code) => {
    try {
      // Kalau kode kosong, langsung reset aja
      if (!code) {
        setPotensialName("")
        return
      }

      const response = await axiosJWT.post('/api/kegiatan-usaha/filter', {
        code: code,
        jml: 1
      })

      // Safety check: pastiin data ada isinya
      if (response.data && response.data.length > 0) {
        setPotensialCode(code)
        setPotensialName(response.data[0].name)
      } else {
        setPotensialName("Data Tidak Ditemukan")
      }
    } catch (err) {
      console.error("Gagal ambil nama potensial:", err)
      setPotensialName("Gagal memuat data")
    }
  }

  const loadFile = (e, index) => {
    const file = e.target.files[0]
    if (!file) return

    const newFiles = [...files]
    newFiles[index] = file
    setFiles(newFiles)

    const newPreviews = [...previews]
    newPreviews[index] = URL.createObjectURL(file)
    setPreviews(newPreviews)
  }

  const getWaktuSekarang = () => {
    const d = new Date()
    const date = d.toISOString().split('T')[0] // Hasil: 2024-06-06
    const time = d.toTimeString().split(' ')[0] // Hasil: 09:59:42
    return `${date} ${time}`
  }

  const proses = async (e) => {
    e.preventDefault()

    try {
      const tanggal = getWaktuSekarang()
      const formData = new FormData()
      formData.append("code", kode)
      formData.append("potensialCode", potensialCode)
      formData.append("potensialName", potensialName)
      formData.append("title", title)
      formData.append("description", description)
      formData.append("tanggal", tanggal)

      files.forEach((file, i) => {
        if (file) {
          // i=0 jadi 'file', i=1 jadi 'file2', dst
          const fieldName = (i === 0) ? 'file' : `file${i + 1}`
          formData.append(fieldName, file)
        }
      })

      const response = await axiosJWT.post('/api/promotion', formData)

      // 2. Success Feedback
      getPesan()
      setMsg(response.data.msg)

      setTimeout(() => {
        getPesan()
        setMsg('')
        getData('') // Refresh list
        closeAdd()  // Tutup modal
      }, 2000)

    } catch (err) {
      getPesan()
      const errorMsg = (err.response && err.response.data && err.response.data.msg)
        ? err.response.data.msg
        : 'Maaf, proses pengiriman data gagal!'
      setMsg(errorMsg)

      setTimeout(() => {
        getPesan()
        setMsg('')
      }, 4000)
    }
  }

  return (<>
    <form onSubmit={proses} className="form-horizontal">
      <h5 className="right-line color-success">Promosi</h5>
      <div className="row">
        <div className="form-group col-md-6">
          <label className="control-label">Kegiatan Usaha</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-filter"></i></span>
            <select className="form-control" value={potensialCode} onChange={(e) => getPotencialName(e.target.value)} required>
              <option value="">==</option>
              {data.map((row, i) => (
                <option key={i} value={row.potensialCode}>{i + 1}. {row.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Judul</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-newspaper-o"></i></span>
            <input type="text" className="form-control" onChange={(e) => setTitle(e.target.value)} value={title} required />
          </div>
        </div>
        <div className="form-group col-md-12">
          <label className="control-label">File Pendukung (Max 5)</label>
          <div className="row">
            {[0, 1, 2, 3, 4].map((i) => ( // Pake 4 kalo mau 4 file aja
              <div key={i} className="col-md-2" style={{ marginBottom: '10px' }}>
                {console.log("Preview ke-" + i + ":", previews[i])} {/* CEK DI CONSOLE */}

                {previews[i] ? (
                  <img src={previews[i]} style={{ width: '100%', height: '100px', objectFit: 'cover' }} alt="preview" />
                ) : (
                  <img src="/assets/img/no-image.png" style={{ width: '100%', height: '100px', objectFit: 'contain' }} alt="none" />
                )}

                <input className="form-control" type="file" accept="image/*"
                  onChange={(e) => loadFile(e, i)} />
              </div>
            ))}
          </div>
          <span className="badge badge-danger">Max 5 File (.JPG, .PNG, .PDF)</span>
        </div>
        <div className="form-group col-md-12">
          <label className="control-label">Deskripsi</label>
          <div className="input-group">
            <span className="input-group-addon"><i className="fa fa-info"></i></span>
            <Texteditor onChange={(description) => { setDescription(description) }} editorLoaded={editorLoaded} required />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-raised btn-primary br-2 no-m" type="Submit"><i className="fa fa-save"></i> Simpan</button>
        <button onClick={closeAdd} className="btn btn btn-raised btn-danger br-2 no-m">
          <i className="fa fa-sign-out"></i> Tutup
        </button>
      </div>
    </form>
  </>)
}